import { Outlet } from "react-router-dom";
import './AuthLayout.css';
import { Layout } from 'antd';

const AuthLayout = () => {
  return (
    <Layout>
      <div className='wrapper'>
        <div className='content-wrapper'>
          <Outlet />
        </div>
      </div>
    </Layout>

  )
};

export default AuthLayout;